import {useMemo, useRef} from 'react';
import {assert} from 'assert-ts';
import isEqual from 'lodash/isEqual';
import {useAppSelector} from 'store/hooks';
import type {ManifestationImportProps} from '../types';
import {selectMetadataEditExportsManifestationById} from '../metadataEditSlice';
import {useCreateSelectorById} from './useCreateSelectorById';
import {useExpressionImportProps} from './useExpressionImportProps';

export const useManifestationImportProps = (
  manifestationId: string,
  expressionId: string,
): ManifestationImportProps => {
  const selectManifestationExports = useCreateSelectorById(
    manifestationId,
    selectMetadataEditExportsManifestationById,
  );
  const manifestationExports = useAppSelector(selectManifestationExports);
  const expressionImports = useExpressionImportProps(expressionId);
  const exportsRef = useRef<ManifestationImportProps>(undefined);

  const imports = useMemo(() => {
    const newExports = {
      ...expressionImports,
      manifestation: assert(
        manifestationExports,
        'useManifestationImportProps: unknown manifestationId',
      ),
    };

    if (!isEqual(newExports, exportsRef.current)) {
      exportsRef.current = newExports;
    }

    return assert(exportsRef.current);
  }, [expressionImports, manifestationExports]);

  return imports;
};
